import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { projectSelectors } from '../../../../store/modules/project';
import routes from '../../../../routes';

const { Router } = routes;

const useRemovedProject = () => {
  const projectError = useSelector(projectSelectors.selectCurrentProjectError);

  useEffect(() => {
    if (!projectError) return;

    const isRemoved = projectError.code === 404;

    isRemoved && Router.pushRoute('my-projects');
  }, [projectError]);
};

export default useRemovedProject;
